import { SelectedValue, FlexSelectValue, OptionsContainer } from './MultiSelectDropdown.styles';

export const getCampaignResultsFromData = ({ campaigns } = {}) => campaigns?.results || [];
export const getJourneyResultsFromData = ({ workflows } = {}) => workflows?.results || [];
export const getExitRulesReesultFromData = ({ exitRules } = {}) => exitRules?.results || [];

export const formatResponse = (data) =>
  data?.map((r) => ({
    ...r,
    key: r.id,
    value: `${r.id}`,
  }));

export const scrollChildIntoView = (childEl, parentEl) => {
  if (!childEl || !parentEl) return;

  const isOutOfUpperView = childEl.offsetTop < parentEl.scrollTop;
  const isOutOfLowerView =
    childEl.offsetTop + childEl.clientHeight > parentEl.scrollTop + parentEl.clientHeight;

  if (isOutOfUpperView) {
    parentEl.scrollTop = childEl.offsetTop;
  } else if (isOutOfLowerView) {
    parentEl.scrollTop = childEl.offsetTop + childEl.clientHeight - parentEl.clientHeight;
  }
};

export const getNextIndex = (arr = [], { currentIndex = 0, offset = 0 } = {}) => {
  const lastIndex = arr.length - 1;
  let nextIndex = currentIndex + offset;

  if (nextIndex > lastIndex) {
    nextIndex = 0;
  } else if (nextIndex < 0) {
    nextIndex = lastIndex;
  }

  return nextIndex;
};

/* ------------------------------- Array Utils ------------------------------ */

export const getIsValueInArray = (val, arr) => arr.includes(val);

const addValueToArray = (val, arr) => [...arr, val];

const removeValueFromArray = (val, arr) => {
  const i = arr.indexOf(val);
  return [...arr.slice(0, i), ...arr.slice(i + 1)];
};

export const toggleValueInArray = (val, arr = []) => {
  if (!val) return [...arr];

  return getIsValueInArray(val, arr) ? removeValueFromArray(val, arr) : addValueToArray(val, arr);
};

export const getSelectedValueNamesInArray = (values, arr) => {
  return arr
    .filter((a) => values.includes(`${a.id}`))
    .map((v) => (
      <SelectedValue key={v.id}>
        {v.name} (ID {v.id})
      </SelectedValue>
    ));
};

export const getExitRuleValueNameInArray = (values, arr) => {
  return (
    <OptionsContainer>
      {arr
        .filter((a) => values.includes(`${a.name}`))
        .map((v) => (
          <FlexSelectValue key={v.name}>
            <span>{v.name}</span>
            <span>{v.id}</span>
          </FlexSelectValue>
        ))}
    </OptionsContainer>
  );
};
